import React from "react";
import { Link } from "react-router-dom";
import {
  FD_WELCOME_BODY,
  FD_WELCOME_DECLINE,
  FD_WELCOME_EXPERIMENT,
  FD_WELCOME_OPT_IN,
  FD_WELCOME_SAFETY,
  FD_WELCOME_TITLE,
  fdWelcomeEventStats,
} from "../copy.js";
import { ReadableNavButton } from "../../../components/Sticker";
import { FieldHint } from "../../../components/createEvent/CreateEventFormUi";
import AttendeeTile from "../components/AttendeeTile.jsx";

export default function WelcomeStep({
  attendees = [],
  eventTotalPicks = 0,
  onOptIn,
  onDecline,
  busy = false,
  showHowItWorks = true,
  howItWorksHref = "/favorite-dances",
  hideTitle = false,
  compactCopy = false,
}) {
  const preview = attendees.slice(0, 8);
  const overflow = attendees.length - preview.length;

  return (
    <div className="space-y-4" data-testid="favorite-dances-welcome">
      {!hideTitle && (
        <p className="font-ui font-semibold text-[16px] text-ink">{FD_WELCOME_TITLE}</p>
      )}

      <FieldHint className="text-[14px] text-ink/75 text-pretty">{FD_WELCOME_BODY}</FieldHint>

      {!compactCopy && (
        <details className="rounded-md2 border border-black/[0.08] bg-white px-3 py-2">
          <summary className="font-ui text-[13px] font-medium text-ink cursor-pointer list-none [&::-webkit-details-marker]:hidden">
            Privacy & how it works
          </summary>
          <div className="mt-2 space-y-2 pb-1">
            <FieldHint className="text-[13px] text-ink/70 text-pretty">{FD_WELCOME_SAFETY}</FieldHint>
            <FieldHint className="text-[13px] text-ink/65 text-pretty">{FD_WELCOME_EXPERIMENT}</FieldHint>
          </div>
        </details>
      )}

      <p
        className="font-ui text-[13px] font-medium text-plum text-center"
        data-testid="favorite-dances-event-stats"
      >
        {fdWelcomeEventStats(eventTotalPicks)}
      </p>

      {preview.length > 0 && (
        <div
          className="grid grid-cols-3 sm:grid-cols-4 gap-3"
          role="group"
          aria-label="Checked-in dancers tonight"
        >
          {preview.map((person) => (
            <AttendeeTile key={person.dancer_id} person={person} readOnly />
          ))}
        </div>
      )}

      {overflow > 0 && (
        <p className="font-ui text-[12px] text-center text-ink/60">+{overflow} more on the floor</p>
      )}

      {showHowItWorks && (
        <Link
          to={howItWorksHref}
          className="inline-block font-ui text-[14px] font-semibold text-plum underline underline-offset-2"
          data-testid="fd-how-it-works-link"
        >
          How it works
        </Link>
      )}

      <div className="flex flex-col gap-2 pt-2">
        <ReadableNavButton
          type="button"
          variant="primary"
          className="w-full py-3.5 text-[15px]"
          disabled={busy}
          onClick={onOptIn}
          data-testid="favorite-dances-opt-in"
        >
          {busy ? "One moment…" : FD_WELCOME_OPT_IN}
        </ReadableNavButton>
        <ReadableNavButton
          type="button"
          variant="default"
          className="w-full py-3 text-[14px]"
          disabled={busy}
          onClick={onDecline}
          data-testid="favorite-dances-decline"
        >
          {FD_WELCOME_DECLINE}
        </ReadableNavButton>
      </div>
    </div>
  );
}
